<template>
	<div class="wallet-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_wallet_page_v2.sec_10.title.one') }}
					<br />
					{{ $t('new_ui.personal_wallet_page_v2.sec_10.title.two') }}
				</h2>
				<p>
					{{ $t('new_ui.personal_wallet_page_v2.sec_10.desc.one') }}<br />
					{{ $t('new_ui.personal_wallet_page_v2.sec_10.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/login" class="btn-type-01">
						{{ $t('new_ui.personal_wallet_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_wallet_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img v-if="!isMobile" :src="img.imgWalletSec10" alt="" />
					<img v-if="isMobile" :src="img.imgWalletSec10M" alt="" />
				</div>
			</div>
		</section>
		<section class="sec-12">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_wallet_page_v2.sec_12.title.one')
					}}<strong>{{
						$t('new_ui.personal_wallet_page_v2.sec_12.title.two')
					}}</strong
					><br />
					{{ $t('new_ui.personal_wallet_page_v2.sec_12.title.three') }}
				</h3>
				<p>
					{{ $t('new_ui.personal_wallet_page_v2.sec_12.desc.one') }}<br />
					{{ $t('new_ui.personal_wallet_page_v2.sec_12.desc.two') }}
				</p>
				<div class="img-box">
					<img :src="img.imgWalletSec12" alt="" />
				</div>
			</div>
		</section>
		<section class="sec-11">
			<div class="container-box">
				<div class="content-box content-01">
					<h3>
						{{ $t('new_ui.personal_wallet_page_v2.sec_11.one.title.one') }}
					</h3>
					<p>
						{{ $t('new_ui.personal_wallet_page_v2.sec_11.one.desc.one') }}<br />
						{{ $t('new_ui.personal_wallet_page_v2.sec_11.one.desc.two') }}
					</p>
				</div>
				<div class="content-box content-02">
					<h3>
						{{ $t('new_ui.personal_wallet_page_v2.sec_11.two.title.one') }}
					</h3>
					<p>
						{{ $t('new_ui.personal_wallet_page_v2.sec_11.two.desc.one') }}<br />
						{{ $t('new_ui.personal_wallet_page_v2.sec_11.two.desc.two') }}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgWalletSec10 from '@/assets/images/v2/img-wallet-sec-10.png';
import imgWalletSec12 from '@/assets/images/v2/img-wallet-sec-12.png';
import imgWalletSec10M from '@/assets/images/v2/img-wallet-sec-10-m.png';

export default {
	data: () => {
		return {
			mobile: false,
			img: {
				imgWalletSec10,
				imgWalletSec12,
				imgWalletSec10M,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
